import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'ap-south-1_vRqMkRZIq',
      userPoolClientId: '3sdpqor4haufvjbfo3kqsk8uvq',
      loginWith: {
        email: true,
      },
    }
  }
});

// MFAラベルのカスタマイズ
window.amplifyUICustomLabels = {
  'Setup TOTP': 'Set up an authenticator app',
  'Confirm TOTP Code': 'Enter the verification code'
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);